import { CampaignData, CampaignTier, GuardiansCampaignUserStats } from "@/types";

export const getLowestUnqualifiedTier = (user: GuardiansCampaignUserStats, data: CampaignData): CampaignTier | null => {
  const { tiers } = data.campaign;
  const { txCount } = user;

  // Keep full CampaignTier objects, only include those with a numeric tx
  const txBasedTiers = tiers.filter((tier): tier is CampaignTier & { tx: number } => typeof tier.tx === "number");

  // Sort tiers in ascending order of tx requirement
  const sortedTiers = txBasedTiers.sort((a, b) => a.tx - b.tx);
  if (txCount === 0) return sortedTiers[0];
  // Return the first tier the user does not qualify for
  return sortedTiers.find((tier) => txCount < tier.tx) || null;
};
export const getHighestQualifiedTier = (user: GuardiansCampaignUserStats, data: CampaignData): CampaignTier | null => {
  const { tiers } = data.campaign;
  const { txCount, rank } = user;
  if (rank <= 100) return tiers.find((t) => t.id === "bonusTier") ?? null;
  // Filter tiers that require a tx count and are satisfied by the user
  const qualifiedTiers = tiers
    .filter((tier) => typeof tier.tx === "number" && txCount >= tier.tx)
    .sort((a, b) => (b.tx ?? 0) - (a.tx ?? 0)); // Sort descending by tx
  return qualifiedTiers[0] || null;
};
